import { PrinterPosStarIcon } from './PrinterPosStarIcon';

/**
 * author: Colton Wiscombe
 * id 6771B76B-C7D3-4F4A-B8AA-1656DF5C445A
 * name printer-pos-star
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-star.svg
 * tags
 * - Printer 
 */
export const PrinterPrimaryIcon = PrinterPosStarIcon;
export default PrinterPrimaryIcon